import { RouteRecordRaw } from 'vue-router';
import { Layout } from '@/router/constant';
import { UserOutlined } from '@vicons/antd';
import { renderIcon } from '@/utils/index';

/**
 * @param name 路由名称, 必须设置,且不能重名
 * @param meta 路由元信息（路由附带扩展信息）
 * @param redirect 重定向地址, 访问这个路由时,自定进行重定向
 * @param meta.disabled 禁用整个菜单
 * @param meta.title 菜单名称
 * @param meta.icon 菜单图标
 * @param meta.keepAlive 缓存该路由
 * @param meta.sort 排序越小越排前
 *
 * */
const routes: Array<RouteRecordRaw> = [
  {
    path: '/user',
    name: 'user',
    redirect: '/user/index',
    component: Layout,
    meta: {
      title: '用户管理',
      icon: renderIcon(UserOutlined),
      sort: 2,
    },
    children: [
      {
        path: 'teacher',
        name: 'teacher-index',
        meta: {
          title: '教师列表',
          roles: ['teacher manager'],
        },
        component: () => import('@/views/teacher/index/index.vue'),
      },
      {
        path: 'student',
        name: 'student-index',
        meta: {
          title: '学生列表',
        },
        component: () => import('@/views/student/index/index.vue'),
      },
      {
        path: 'klass',
        name: 'klass-index',
        meta: {
          title: '班级列表',
        },
        component: () => import('@/views/klass/index/index.vue'),
      },
      {
        path: 'klass/create',
        name: 'klass-create',
        meta: {
          title: '新增班级',
          hidden: true,
        },
        component: () => import('@/views/klass/createOrEdit/index.vue'),
      },
      {
        path: 'klass/edit/:id',
        name: 'klass-edit',
        meta: {
          title: '修改班级',
          hidden: true,
        },
        component: () => import('@/views/klass/createOrEdit/index.vue'),
      },
      {
        path: 'klass/:id/grade',
        name: 'klass-grade',
        meta: {
          title: '成绩',
          hidden: true,
        },
        component: () => import('@/views/klass/grade/index.vue'),
      },
    ],
  },
];

export default routes;
